import { inventoryByProductVersionFromFirestore } from '@parallel-fluidics/shared/models/inventory';
import {
  collection,
  getFirestore,
  orderBy,
  where,
} from 'firebase/firestore';
import useCustomInfiniteQuery from 'hooks/use-customInfiniteQuery';
import { useMemo } from 'react';

export default function useInventoryByProductVersionQuery({ filterText = '', pageSize = 25 }) {
  const queryParams = useMemo(() => {
    const base = collection(getFirestore(), 'inventoryByProductVersion');
    const normalizedFilter = filterText.trim().toUpperCase();

    if (normalizedFilter) {
      return [
        base,
        orderBy('sku', 'asc'),
        where('sku', '>=', normalizedFilter),
        where('sku', '<=', `${normalizedFilter}\uf8ff`),
      ];
    }

    return [
      base,
      orderBy('updatedAt', 'desc'),
    ];
  }, [filterText]);

  return useCustomInfiniteQuery({
    queryKey: 'getInventoryByProductVersionData',
    queryParams,
    pageSize,
    staleTime: 10 * 60 * 1000,
    transformData: inventoryByProductVersionFromFirestore,
  });
}
